import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import { isVue2 } from 'vue-demi';
import UiToast from './Toast';
import { useExtend } from '../_use';
import { isServer } from '../_util/is-server';
let multiple;
const stack = [];
const defaultSetting = {
  type: 'msg',
  message: '',
  duration: 2000,
  dangerouslyUseHTMLString: false,
  position: 'middle',
  toastClass: '',
  toastStyle: null,
  transition: '',
  teleport: 'body',
  icon: '',
  notice: false,
  closable: false,
  forbidClick: false,
  onOpen: null,
  onClose: null
};
function parseParam(options) {
  return _Object$assign({}, defaultSetting, typeof options === 'string' ? {
    message: options
  } : options);
}
function Toast(options) {
  if (isServer()) return {};
  let instanceObj;
  if (stack.length === 0 || multiple) {
    instanceObj = useExtend(UiToast); // PortalMixin会处理dom节点
    stack.push(instanceObj);
  } else {
    instanceObj = stack[stack.length - 1];
  }
  const {
    instance
  } = instanceObj;
  _Object$assign(isVue2 ? instance : instance._.props, options, {
    onClose: function onClose(_ref) {
      let {
        id
      } = _ref;
      if (multiple || stack.length > 1) {
        // multi情况下就销毁，非multi的时候也保持stack里只有一个
        for (let index = 0; index < stack.length; index++) {
          const item = stack[index];
          if (item.instance.id === id) {
            item.unmount();
            stack.splice(index, 1);
            break;
          }
        }
      }
      const customOnClose = options.onClose;
      if (typeof customOnClose === 'function') {
        customOnClose();
      }
    }
  });
  instance.open();
  return instance;
}
const theToast = {};
['msg', 'success', 'error', 'loading', 'warning', 'info'].forEach(type => {
  theToast[type] = options => Toast(_objectSpread(_objectSpread({}, parseParam(options)), {}, {
    type
  }));
});
theToast.close = function () {
  let clearAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const len = stack.length;
  if (!len) return;
  if (clearAll) {
    stack.forEach(toast => {
      toast.instance.close();
    });
  } else {
    for (let i = 0; i < len; i++) {
      if (stack[i].instance.show) {
        stack[i].instance.close(); // 最前面一个没隐藏的隐藏
        break;
      }
    }
  }
};
theToast.allowMultiple = function () {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  multiple = value;
};
export default _Object$assign(UiToast, theToast);